module.exports = __webpack_public_path__ + "plus.9a8325a7d84669ffcdcf.png";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/common-images/reports/plus.png
// module id = ../../../../syncfusion-javascript/Content/ej/web/common-images/reports/plus.png
// module chunks = 2